// @flow
// eslint-disable-next-line import/no-extraneous-dependencies
import { isFunction } from 'lodash';
import type { TFunction } from '@app/components/translation';
import type { Validator } from './index';

const numberPattern = /^\d+$/;
const getNumberDecimalsPattern = (decimals) => new RegExp(`^\\d+(\\.\\d{0,${decimals}})?$`);

type NumberValidator = ({
  t?: TFunction,
  field: string,
  text?: string,
  decimals?: number,
}) => Validator;

// NOTE: meant to be used only in number input
const numberValidator: NumberValidator = ({
  t, field, text, decimals,
}) => (value: string) => {
  if (value === undefined || numberPattern.test(value)) {
    return undefined;
  }

  if (!decimals) {
    if (text) {
      return text;
    }
    if (!t || !isFunction(t)) {
      throw new Error('The translation function (t) is mandatory for creating a validation.');
    }

    return t('{field} is not a valid number', {
      field,
      _comment: 'Validation message for number validator.',
    });
  }

  if (getNumberDecimalsPattern(decimals).test(value)) {
    return undefined;
  }

  if (text) {
    return text;
  }

  if (!t || !isFunction(t)) {
    throw new Error('The translation function (t) is mandatory for creating a validation.');
  }

  return t('Not allowed to have more than {count, plural, one {# decimal} other {# decimals}}', {
    count: decimals,
    _comment: 'Validation message for number of decimals validator.',
  });
};

export default numberValidator;
